import { useMemo } from 'react';

import type { PageSizesProps } from '#pagination/components/types/page-sizes.props';

import { DEFAULT_PAGE_SIZE_OPTIONS } from '#pagination/constants/default-page-size-options';

/**
 * Custom hook to generate configuration for page size options in pagination components.
 *
 * @param params - An object containing the `pageSizes` array, which specifies the selectable page sizes.
 *                 If not provided, defaults to `DEFAULT_PAGE_SIZE_OPTIONS`.
 * @returns An object with a `pageSizeOptions` array, where each option has a `label` and `value` property.
 *
 * @example
 * const { pageSizeOptions } = usePageSizesConfiguration({ pageSizes: [10, 20, 50] });
 */
export const usePageSizesConfiguration = ({
  pageSizes = DEFAULT_PAGE_SIZE_OPTIONS,
}: Pick<PageSizesProps, 'pageSizes'>) => {
  const pageSizeOptions = useMemo(() => {
    return pageSizes.map((value) => {
      return { label: value, value };
    });
  }, [pageSizes]);

  return { pageSizeOptions };
};
